import React from "react";
import { Rate, Tag } from "antd";
import "./index.css";

export default function Badge({
  productStatus,
  orderStatus,
  paymentStatus,
  rating,
  quantity,
  active,
}) {
  let color, label;

  if (rating) {
    label = rating;
  } else if (productStatus) {
    if (productStatus === "available" || productStatus === "in stock") {
      color = "green";
    } else if (productStatus === "out of stock") {
      color = "red";
    } else if (productStatus === "plenty") {
      color = "green";
    } else {
      color = "yellow";
    }
    label = productStatus;
  } else if (orderStatus) {
    if (orderStatus === "order_paid") {
      color = "green";
      label = "Paid";
    } else if (orderStatus === "order_unpaid") {
      color = "orange";
      label = "Unpaid";
    } else if (orderStatus === "order_created") {
      color = "blue";
      label = "Created";
    } else if (orderStatus === "order_updated") {
      color = "blue";
      label = "Updated";
    } else if (orderStatus === "order_failed") {
      color = "red";
      label = "Failed";
    } else if (
      orderStatus === "order_cancelled" ||
      orderStatus === "CANCELLED"
    ) {
      color = "red";
      label = "Cancelled";
    } else if (orderStatus === "partially_packed") {
      color = "purple";
      label = "Partially Packed";
    } else if (orderStatus === "packed") {
      color = "purple";
      label = "Packed";
    } else if (orderStatus === "dispatched") {
      color = "orange";
      label = "Dispatched";
    } else if (orderStatus === "delivered") {
      color = "cyan";
      label = "Delivered";
    } else {
      label = orderStatus;
    }
  } else if (paymentStatus) {
    if (paymentStatus === "captured") {
      color = "green";
      label = "Received";
    } else if (paymentStatus === "created") {
      color = "blue";
      label = "Initiated";
    } else if (paymentStatus === "refunded") {
      color = "orange";
      label = "Refunded";
    } else if (paymentStatus === "failed") {
      color = "red";
      label = "Failed";
    } else {
      label = paymentStatus;
    }
  } else if (quantity) {
    label = quantity;
  } else if (active === 1) {
    color = "green";
    label = "Active";
  } else if (active === 0) {
    color = "red";
    label = "Inactive";
  } else {
    label = "NA";
  }

  return rating ? (
    <Rate
      style={{ cursor: "pointer" }}
      allowHalf
      value={parseFloat(label)}
      disabled
    />
  ) : (
    <Tag style={{ textTransform: "capitalize" }} color={color}>
      {label}
    </Tag>
  );
}
